import React from 'react'
import { Button, Col, Form, Row, Select, Table } from 'antd'
import FilterContainer from '../../../../components/common/FilterContainer'
import { propertyList, tableColumns, tableData } from '../surveysData'

import { useNavigate } from 'react-router-dom';


const Responses = () => {
  const navigate = useNavigate();

  return (
    <div>
      <Row>
        <Col span={24}>
          <FilterContainer heading="Filter surveys using the filter below:">
            <Form
              name="basic"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 16 }}
              initialValues={{ remember: true }}
              autoComplete="off"
              colon={false}
            >
              <Form.Item label="Property">
                <Select
                  showSearch
                  placeholder="Search by property, group, or portfolio"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[]}
                />
              </Form.Item>

              <Form.Item label=" ">
                <Button type="primary" htmlType="submit">
                  Search
                </Button>
              </Form.Item>
            </Form>
          </FilterContainer>
        </Col>
      </Row>
      <Table columns={tableColumns} dataSource={[]} 
      rowKey="key"
        onRow={(record, rowIndex) => {
          return {
            onClick: (event) => {
              console.log("Clicked Row:", record);
              navigate('/reporting/surveys/details', { state: { rowData: record } });
            },
          };
        }}
      />
    </div>
  )
}

export default Responses
